import React, { useEffect } from "react";
import { useState } from "react";
import "./Boton.css";

import { firestoreConnect } from "react-redux-firebase";

const Boton = (props) => {
  // ammount to add on each button press
  const confettiCount = 20;
  const sequinCount = 10;

  // "physics" variables
  const gravityConfetti = 0.3;
  const gravitySequins = 0.55;
  const dragConfetti = 0.075;
  const dragSequins = 0.02;
  const terminalVelocity = 3;

  // init other global elements
  const [button, setButton] = useState("");
  var disabled = false;

  // add Confetto/Sequin objects to arrays to draw them
  let confetti = [];
  let sequins = [];

  // colors, back side is darker for confetti flipping
  const colors = [
    { front: "#A741AF", back: "#712D77" }, // morado
    { front: "#42D4FC", back: "#2C95B2" }, // azul claro
    { front: "#ED3E75", back: "#A13356" }, // rosa
  ];

  // helper function to pick a random number within a range
  const randomRange = (min, max) => Math.random() * (max - min) + min;

  // helper function to get initial velocities for confetti
  // this weighted spread helps the confetti look more realistic
  const initConfettoVelocity = (xRange, yRange) => {
    const x = randomRange(xRange[0], xRange[1]);
    const range = yRange[1] - yRange[0] + 1;
    let y =
      yRange[1] -
      Math.abs(randomRange(0, range) + randomRange(0, range) - range);
    if (y >= yRange[1] - 1) {
      // Occasional confetto goes higher than the max
      y += Math.random() < 0.25 ? randomRange(1, 3) : 0;
    }
    return { x: x, y: -y };
  };

  // Confetto Class
  function Confetto() {
    let button = document.getElementById("button");
    let canvas = document.getElementById("canvas");
    this.randomModifier = randomRange(0, 99);
    this.color = colors[Math.floor(randomRange(0, colors.length))];
    this.dimensions = {
      x: randomRange(5, 9),
      y: randomRange(8, 15),
    };
    this.position = {
      x: randomRange(
        canvas.width / 2 - button.offsetWidth / 4,
        canvas.width / 2 + button.offsetWidth / 4
      ),
      y: randomRange(
        canvas.height / 2 + button.offsetHeight / 2 + 8,
        canvas.height / 2 + 1.5 * button.offsetHeight - 8
      ),
    };
    this.rotation = randomRange(0, 2 * Math.PI);
    this.scale = {
      x: 1,
      y: 1,
    };
    this.velocity = initConfettoVelocity([-9, 9], [6, 11]);
  }
  Confetto.prototype.update = function() {
    // apply forces to velocity
    this.velocity.x -= this.velocity.x * dragConfetti;
    this.velocity.y = Math.min(
      this.velocity.y + gravityConfetti,
      terminalVelocity
    );
    this.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();

    // set position
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;

    // spin confetto by scaling y and set the color, .09 just slows cosine frequency
    this.scale.y = Math.cos((this.position.y + this.randomModifier) * 0.09);
  };

  // Sequin Class
  function Sequin() {
    let button = document.getElementById("button");
    let canvas = document.getElementById("canvas");
    this.color = colors[Math.floor(randomRange(0, colors.length))];
    this.radius = randomRange(1, 2);
    this.position = {
      x: randomRange(
        canvas.width / 2 - button.offsetWidth / 3,
        canvas.width / 2 + button.offsetWidth / 3
      ),
      y: randomRange(
        canvas.height / 2 + button.offsetHeight / 2 + 8,
        canvas.height / 2 + 1.5 * button.offsetHeight - 8
      ),
    };
    this.velocity = {
      x: randomRange(-6, 6),
      y: randomRange(-8, -12),
    };
  }
  Sequin.prototype.update = function() {
    // apply forces to velocity
    this.velocity.x -= this.velocity.x * dragSequins;
    this.velocity.y = this.velocity.y + gravitySequins;

    // set position
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;
  };

  // add elements to arrays to be drawn
  const initBurst = () => {
    for (let i = 0; i < confettiCount; i++) {
      confetti.push(new Confetto());
    }
    for (let i = 0; i < sequinCount; i++) {
      sequins.push(new Sequin());
    }
  };

  // draws the elements on the canvas
  const render = () => {
    let canvas = document.getElementById("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    confetti.forEach((confetto, index) => {
      let width = confetto.dimensions.x * confetto.scale.x;
      let height = confetto.dimensions.y * confetto.scale.y;

      // move canvas to position and rotate
      ctx.translate(confetto.position.x, confetto.position.y);
      ctx.rotate(confetto.rotation);

      // update confetto "physics" values
      confetto.update();

      // get front or back fill color
      ctx.fillStyle =
        confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;

      // draw confetto
      ctx.fillRect(-width / 2, -height / 2, width, height);

      // reset transform matrix
      ctx.setTransform(1, 0, 0, 1, 0, 0);

      // clear rectangle where button cuts off
      if (confetto.velocity.y < 0) {
        ctx.clearRect(
          canvas.width / 2 - button.offsetWidth / 2,
          canvas.height / 2 + button.offsetHeight / 2,
          button.offsetWidth,
          button.offsetHeight
        );
      }
    });

    sequins.forEach((sequin, index) => {
      // move canvas to position
      ctx.translate(sequin.position.x, sequin.position.y);

      // update sequin "physics" values
      sequin.update();

      // set the color
      ctx.fillStyle = sequin.color;

      // draw sequin
      ctx.beginPath();
      ctx.arc(0, 0, sequin.radius, 0, 2 * Math.PI);
      ctx.fill();

      // reset transform matrix
      ctx.setTransform(1, 0, 0, 1, 0, 0);

      // clear rectangle where button cuts off
      if (sequin.velocity.y < 0) {
        ctx.clearRect(
          canvas.width / 2 - button.offsetWidth / 2,
          canvas.height / 2 + button.offsetHeight / 2,
          button.offsetWidth,
          button.offsetHeight
        );
      }
    });

    // remove confetti and sequins that fall off the screen
    // must be done in seperate loops to avoid noticeable flickering
    confetti.forEach((confetto, index) => {
      if (confetto.position.y >= canvas.height) confetti.splice(index, 1);
    });
    sequins.forEach((sequin, index) => {
      if (sequin.position.y >= canvas.height) sequins.splice(index, 1);
    });

    window.requestAnimationFrame(render);
  };

  useEffect(() => {
    let button = document.getElementById("button");
    setButton(document.getElementById("button"));

    let textElements = button.querySelectorAll(".button-text");
    textElements.forEach((element) => {
      let characters = element.innerText.split("");
      let characterHTML = "";
      characters.forEach((letter, index) => {
        characterHTML += `<span class="char${index}" style="--d:${index *
          30}ms; --dr:${(characters.length - index - 1) *
          30}ms;">${letter}</span>`;
      });
      element.innerHTML = characterHTML;
    });

    render();
  }, []);

  const [state, setState] = useState({
    nombre: "",
    email: "",
    mensaje: "",
    telefono: "",
    fecha: new Date(),
    archivar: false,
  });

  const leerDato = (e) => {
    e.preventDefault();
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const enviarMensaje = async (e) => {
    e.preventDefault();
    const { firestore } = props;

    if (!disabled) {
      disabled = true;
      // Loading stage
      button.classList.add("loading");
      button.classList.remove("ready");

      firestore
        .add(
          {
            collection: "mensajes",
          },
          state
        )
        .then(() => {
          // Completed stage
          button.classList.add("complete");
          button.classList.remove("loading");
          setTimeout(() => {
            initBurst();
            render();
            setTimeout(() => {
              // Reset button so user can select it again
              disabled = false;
              button.classList.add("ready");
              button.classList.remove("complete");
              setTimeout(() => {
                window.location.replace("/envio-exitoso");
              }, 1000);
              // timepo necesaario para que se vea todo el efecto del confeti
              // }, 2000);
            }, 2000);
          }, 320);
        });
    }
  };

  return (
    <div style={{ marginTop: "20px", marginBottom: "-20px" }}>
      <form
        className="container"
        id="formulario"
        style={{ marginBottom: "30px" }}
        onSubmit={enviarMensaje}
      >
        <div className="row" style={{ marginBottom: "-10px" }}>
          <div className="col s12 m12 l6">
            <div class="input-field" style={{ marginBottom: "0" }}>
              <input
                name="nombre"
                type="text"
                placeholder="Nombre"
                className="validate formulario_contacto"
                onChange={leerDato}
                required
                style={{ backgroundColor: "white" }}
              />
            </div>
          </div>

          <div className="col s12 m12 l6">
            <div class="input-field" style={{ marginBottom: "0" }}>
              <input
                name="telefono"
                pattern="[0-9]+"
                minlength="10"
                maxlength="10"
                type="tel"
                placeholder="Telefono"
                className="validate formulario_contacto"
                onChange={leerDato}
                required
                style={{ backgroundColor: "white" }}
              />
              {/* <input
                type="tel"
                id="telefono"
                name="telefono"
                pattern="[0-9]+"
                minlength="10"
                maxlength="10"
                required
              /> */}
            </div>
          </div>

          <div className="col s12 m12 12">
            <div className="input-field" style={{ marginBottom: "0" }}>
              <input
                name="email"
                type="email"
                className="validate formulario_contacto"
                placeholder="E-mail"
                onChange={leerDato}
                required
                style={{ backgroundColor: "white" }}
              />
            </div>
          </div>

          <div className="col s12 m12 l12">
            <div className="input-field">
              <textarea
                placeholder="Mensaje"
                name="mensaje"
                className="materialize-textarea form_tetxtarea formulario_contacto_2"
                onChange={leerDato}
                required
                style={{ backgroundColor: "white" }}
              ></textarea>
            </div>
          </div>
        </div>
        <button id="button" className="ready">
          <div className="message submitMessage">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12.2">
              <polyline stroke="currentColor" points="2,7.1 6.5,11.1 11,7.1 " />
              <line
                stroke="currentColor"
                x1="6.5"
                y1="1.2"
                x2="6.5"
                y2="10.3"
              />
            </svg>{" "}
            <span className="button-text">Enviar</span>
          </div>
          <div className="message loadingMessage">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 17">
              <circle className="loadingCircle" cx="2.2" cy={10} r="1.6" />
              <circle className="loadingCircle" cx="9.5" cy={10} r="1.6" />
              <circle className="loadingCircle" cx="16.8" cy={10} r="1.6" />
            </svg>
          </div>
          <div className="message successMessage">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 11">
              <polyline
                stroke="currentColor"
                points="1.4,5.8 5.1,9.5 11.6,2.1 "
              />
            </svg>{" "}
            <span className="button-text">Enviado</span>
          </div>
        </button>
      </form>

      <canvas id="canvas" />
    </div>
  );
};

export default firestoreConnect()(Boton);
